import React from 'react';
import { Title, Text } from '../Typography';
import { BigNumberProps } from './types';
import {
  BigNumbersContainer,
  ItemNumberContainer,
  BottomNumber,
  BottomText,
  TopNumber,
  ContentTopCurve,
  SvgContainer,
} from './styles';

export function BigNumbers({ items }: BigNumberProps) {
  return (
    <BigNumbersContainer data-test="bignumbers" data-print="hide">
      {items.map((el, key) => (
        <ItemNumberContainer key={key}>
          <TopNumber>
            <Title tag="div" type="lg">
              <div dangerouslySetInnerHTML={{ __html: el.bigNumber }} />
            </Title>
          </TopNumber>
          <BottomNumber className="bg-corporate-blue">
            <SvgContainer>
              <ContentTopCurve>
                <svg
                  id="contentTopCurve"
                  data-test="svg-other-variation-exists"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 624 28"
                >
                  <path
                    fill="#010E54"
                    d="M16 203C7.16344 203 0 195.837 0 187V21.351C0 21.351 143.433 -1.4836e-05 313.3 0C483.167 1.48361e-05 624 21.3511 624 21.3511V187C624 195.837 616.836 203 608 203H16Z"
                  />
                </svg>
              </ContentTopCurve>
              <Text tag="div" type="link" className="text-white">
                <BottomText className="absolute top-1/2 transform -translate-y-1/2 w-full px-8" dangerouslySetInnerHTML={{ __html: el.bottomText }} />
              </Text>
            </SvgContainer>
          </BottomNumber>
        </ItemNumberContainer>
      ))}
    </BigNumbersContainer>
  );
}

BigNumbers.defaultProps = {
  items: [],
};
